<template>
  <!--
    	作者：kmdshop
    	时间：2020-06-20
    	描述：diy组件-模拟显示-限时秒杀
    -->
  <div class="drag optional" :class="{ selected: index === selectedIndex }" @click.stop="$parent.$parent.onEditer(index)">
    <div class="diy-seckill" :style="{ background: item.style.background }">
      <div class="diy-head d-b-c" :style="{ color: item.style.color }">
        <div class="left d-s-c">
          <div class="name">会员专区</div>
        </div>
        <div class="right">更多</div>
      </div>
      <ul class="product-list" :class="['column__' + item.style.column]" :style="getUlwidth(item)">
        <li class="product-item" v-for="(product, index) in item.data" :key="index">
          <!-- 两列三列 -->
          <div class="product-cover">
            <img v-img-url="product.image" />
          </div>
          <div class="product-info p-0-10">
            <div class="product-title">{{ product.product_name }}</div>
            <div class="price d-b-c f12">
              <div v-if="item.style.show.nextPrice == '1'">
                <span>会员价</span>
                <span class="orange">¥120</span>
              </div>
              <div class="gray6">
                <span>当前价</span>
                <span>¥233</span>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="btn-edit-del"><div class="btn-del" @click.stop="$parent.$parent.onDeleleItem(index)">删除</div></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      /*分类id*/
      category_id: 0
    };
  },
  created() {},
  props: ['item', 'index', 'selectedIndex'],
  methods: {
    /*计算宽度*/
    getUlwidth(item) {
      if (item.style.display == 'slide') {
        let total = 0;
        if (item.params.source == 'choice') {
          total = item.data.length;
        } else {
          total = item.defaultData.length;
        }
        let w = 0;
        if (item.style.column == 2) {
          w = total * 150;
        } else {
          w = total * 100;
        }
        return 'width:' + w + 'px;';
      }
    }
  }
};
</script>

<style>
.diy-seckill {
  border-radius: 10px 10px 0 0;
}
.diy-seckill .diy-head {
  padding: 0 10px;
  height: 40px;
}
.diy-seckill .diy-head .name {
  font-size: 18px;
  font-weight: bold;
}
.diy-seckill .diy-head .datetime {
  margin-left: 20px;
}
.diy-seckill .diy-head .datetime > span {
  display: inline-block;
}
.diy-seckill .diy-head .datetime .text {
  padding: 0 4px;
}
.diy-seckill .diy-head .datetime .box {
  padding: 2px;
  border-radius: 4px;
  background: #000000;
  color: #ffffff;
}
.diy-seckill .product-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.diy-seckill .product-list.column__1 .product-item {
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  padding: 10px;
  border-bottom: 1px solid #dddddd;
  background: #ffffff;
  width: 100%;
}

.diy-seckill .product-list.column__1 .product-item-box {
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
}

.diy-seckill .product-list.column__1 .product-cover {
  width: 100px;
  height: 100px;
}

.diy-seckill .product-list.column__1 .product-info {
  margin-left: 10px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.diy-seckill .product-list .product-title {
  margin-top: 4px;
  height: 40px;
  line-height: 20px;
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.diy-seckill .display__list .column__2,
.diy-seckill .display__list .column__3 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.diy-seckill .product-list.column__2 .product-item {
  width: 170px;
  margin-bottom: 10px;
  margin-left: 5px;
  background: #ffffff;
}
.diy-seckill .product-list.column__2 .product-item .product-cover {
  width: 170px;
  height: 170px;
  overflow: hidden;
}

.diy-seckill .product-list.column__3 .product-item {
  width: 110px;
  margin-bottom: 10px;
  margin-left: 6px;
  background: #ffffff;
}
.diy-seckill .product-list.column__3 .product-item .product-cover {
  width: 110px;
  height: 110px;
  overflow: hidden;
}
.diy-seckill .product-list.column__3 .product-item .product-cover img {
  width: 110px;
}

.diy-seckill .product-list.column__2 .product-title,
.diy-seckill .product-list.column__3 .product-title {
  height: 40px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/model/VipArea.vue